/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Thelabelsarrayassociatedwiththeiban
 */

// required attributes
const IbanLabelR = t.interface({
  description: t.string,

  name: t.string
});

// optional attributes
const IbanLabelO = t.partial({});

export const IbanLabel = t.intersection([IbanLabelR, IbanLabelO], "IbanLabel");

export type IbanLabel = t.TypeOf<typeof IbanLabel>;
